/* eslint-disable */
const $ = jQuery.noConflict();

'use strict';
const Shop = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		if ($('body.woocommerce-shop').length < 1 && $('body.tax-product_cat').length < 1 && $('body.tax-brand').length < 1) {
			return false;
		}
		// if ($('.js-action-shop-link').length > 0) {
		// 	this.actionProductsParamChange();
		// }
		this.postPerPage();
		this.priceRange();
		this.preselectCustomValues();
		// this.customSort();
		this.pills();
		this.createPillsOnLoad();
		this.closePill();
		this.subCategoriesUpdate();
		this.mobileFilters();
		$('.products-listing__holder-products-pagination-num, .products-listing__holder-products-pagination-btn, .products-listing__holder-products-pagination-input-btn').on('click', function() {
			$('html, body').animate({scrollTop: 0}, 'slow');
		});
		$(document).ajaxStop(function() {
			const urlParams = new URLSearchParams(window.location.search);
			Shop.precheckedOptions(urlParams);
			$('.sf-field-taxonomy-brand h4').on('click', function() {
				$('.sf-field-taxonomy-brand h4').addClass('is-active');
				$('.sf-field-taxonomy-brand ul').slideDown();
			});
			$('.site-content > .woocommerce-breadcrumb').replaceWith($('.js-ajax-breadcrumb .woocommerce-breadcrumb'));
		});
		$(document).on('click', '.search-filter-reset', function() {
			$('.js-example-pill:visible').remove();
			$('.js-products-listing__holder-upper-categories').html('');
		});
		$('.js-price-range-radio-custom').insertBefore($('.sf-field-reset'));
	},

	mobileFilters: function() {
		const filtersBtn = document.querySelector('.js-show-filters-btn');
		const filtersSidebar = document.querySelector('.products-listing__filters');
		// add overlay
		let overlay = document.querySelector('.products-listing__filters-overlay');
		if (!overlay) {
			overlay = document.createElement('div');
			overlay.className = 'products-listing__filters-overlay';
			document.body.appendChild(overlay);
		}

		filtersBtn?.addEventListener('click', function() {
			filtersSidebar.classList.add('is-active');
			overlay.classList.add('is-active');
			document.body.classList.add('no-scroll');
		});

		overlay.addEventListener('click', Shop.closeFilters);

		// close filters on change
		filtersSidebar?.addEventListener('click', function(e) {
			const target = e.target;
			console.log(target.tagName);

			if (target.tagName === 'SELECT' || target.tagName === 'LI') {
				if (window.innerWidth < 992) Shop.closeFilters();
			}
		});
	},

	closeFilters: function() {
		const filtersSidebar = document.querySelector('.products-listing__filters');
		const overlay = document.querySelector('.products-listing__filters-overlay');
		filtersSidebar.classList.remove('is-active');
		overlay.classList.remove('is-active');
		document.body.classList.remove('no-scroll');
	},

	actionProductsParamChange: function() {
		$(document).on('click', '.js-action-shop-link', function(e) {
			e.preventDefault();
			window.history.replaceState({}, '', window.origin + '/shop?on_sale=true');
		});
	},

	pills: function() {
		$(document).on('click', '.searchandfilter input[type="radio"], .searchandfilter input[type="checkbox"]', function() {
			let isPrice = false;
			let isCat = false;
			if ($(this).is(':checked')) {
				if ($(this).attr('name') === 'price_range_custom') {
					isPrice = true;
					$('.js-pill-name[data-price="true"]').parent().remove();
					if (!$(this).hasClass('js-all-prices')) {
						Shop.generatePill($(this).val(), isPrice);
					}
				} else if ($(this).attr('name') === '_sft_product_cat[]') {
					Shop.subCategoriesUpdate();
					isCat = true;
					$('.js-pill-name[data-cat="true"]').parent().remove();
					Shop.generatePill($(this).val(), false, isCat);
				} else {
					console.log('test', $(this).val());
					Shop.generatePill($(this).val(), false, false);
				}
			} else {
				$(`.js-pill-name[data-id="${$(this).val()}"]`).parent().remove();
			}
		});
	},

	createPillsOnLoad: function() {
		const checkboxes = document.querySelectorAll('input[name="_sft_brand[]"]:checked');
		const cats = document.querySelectorAll('input[name="_sft_product_cat[]"]:checked');
		const priceRadio = document.querySelectorAll('input[name="price_range_custom"]:checked');

		if (checkboxes.length > 0) {
			for (let i = 0; i < checkboxes.length; i++) {
				Shop.generatePill(checkboxes[i].value);
			}
		}

		if (cats.length > 0) {
			for (let i = 0; i < cats.length; i++) {
				Shop.generatePill(cats[i].value, false, true);
			}
		}

		if (priceRadio.length > 0) {
			for (let i = 0; i < priceRadio.length; i++) {
				Shop.generatePill(priceRadio[i].value, true);
			}
		}
	},

	generatePill: function(value, isPrice = false, isCat = false) {
		const examplePill = document.querySelector('.js-example-pill');
		const clonePill = examplePill.cloneNode(true);
		clonePill.style.display = 'block';
		const clonePillNameHolder = clonePill.querySelector('.js-pill-name');
		clonePillNameHolder.innerText = value;
		console.log(value);
		if (value) {
			clonePillNameHolder.setAttribute('data-id', value);
			if (isPrice) {
				clonePillNameHolder.setAttribute('data-price', true);
			}
			if (isCat) {
				clonePillNameHolder.setAttribute('data-cat', true);
			}
			const wrap = $('.js-products-listing__holder-products-pills');
			$(clonePill).appendTo(wrap);
		}
	},

	closePill: function() {
		$(document).on('click', '.js-close-pill', function() {
			const pillNameEle = $(this).parent().find('.js-pill-name');
			const input = $(`.searchandfilter input[value="${pillNameEle.attr('data-id')}"]`);
			if (input.length > 0) {
				if (input.attr('name') === 'price_range_custom') {
					input.prop('checked', false);
					$('.js-all-prices').trigger('click');
				} else if (input.attr('name') === '_sft_product_cat[]') {
					input.prop('checked', false);
					document.querySelector('input[name="_sft_product_cat[]"]').click();
				} else {
					input.trigger('click');
				}
				$(this).parent().remove();
			}
		});
	},

	preselectCustomValues: function() {
		const urlParams = new URLSearchParams(window.location.search);
		Shop.precheckedOptions(urlParams);
		const perPageParam = urlParams.get('_sf_ppp');
		const paged = urlParams.get('sf_paged');
		if (perPageParam) {
			$('.js-custom-per-page').val(perPageParam).trigger('change.select2');
		}

		const orderBy = urlParams.get('orderby');
		if (orderBy) {
			// $('.js-custom-per-price').val(orderBy).trigger('change.select2');
		}
	},

	precheckedOptions: function(urlParams) {
		const priceParam = urlParams.get('_sfm__price');
		if (priceParam) {
			const priceParamReplace = priceParam.replace(' ', '-');
			if (priceParamReplace) {
				$(`.js-price-range-radio-custom input[type="radio"][value="${priceParamReplace}"]`).prop('checked', true);
			}
			if (priceParamReplace === '0-10000000') {
				$('.js-price-range-radio-custom input').prop('checked', false);
			}
		}
	},

	postPerPage: function() {

		const handleChange = (e) => {
			const ele = e.currentTarget;
			const option = $(`.sf-field-posts_per_page select option[value="${ele.value}"]`);
			if (option.length > 0) {
				$('.sf-field-posts_per_page select').val(ele.value).trigger('change');
			}
		};

		$(document).on('change', '.js-custom-per-page', handleChange);
	},

	priceRange: function() {
		$(document).on('click', '.js-price-range-radio-custom input[type="radio"]', function() {
			const val = $(this).val().split('-');
			$('.sf-range-min').val(val[0]);
			$('.sf-range-max').val(val[1]);
			$('.sf-range-max').trigger('input');
		});
	},

	customSort: function() {

		const handleChange = (e) => {
			const ele = e.currentTarget;
			const option = $(`.woocommerce-ordering select.orderby option[value="${ele.value}"]`);
			if (option.length > 0) {
				$('.woocommerce-ordering select.orderby').val(ele.value).trigger('change');
			}


		};

		$(document).on('change', '.js-custom-sort', handleChange);
	},

	subCategoriesUpdate: function() {
		$('.js-products-listing__holder-upper-categories').html('');
		const activeParentCats = document.querySelectorAll('.sf-field-taxonomy-product_cat input[name="_sft_product_cat[]"]:checked');
		if (activeParentCats.length > 0) {
			const slugs = [];
			for (let i = 0; i < activeParentCats.length; i++) {
				const children = activeParentCats[i].parentElement.querySelectorAll('ul.children input[name="_sft_product_cat[]"]');
				console.log(children);
				if (children) {
					for (let x = 0; x < children.length; x++) {
						const countEle = children[x].parentElement.querySelector('.sf-count');
						const countNum = countEle.innerHTML.replace(/\D/g, '');
						if (parseInt(countNum) > 0) {
							slugs.push({
								slug: children[x].value,
								count: countEle.innerHTML
							});
						}
					}
				}


			}

			const data = {
				action: 'shop_sub_categories',
				data: slugs
			};

			// Shop.ajaxFunction(data);
		}
	},

	ajaxFunction: function(data) {
		$.ajax({
			datatype: 'json',
			type: 'POST',
			url: window.techno_ferum_ajax.ajax_url,
			data,
			success: function(response) {
				if (response.success) {
					$('.js-products-listing__holder-upper-categories').replaceWith(response.data);
				}
			}
		});
	},
};

export default Shop;
